import React from "react";
import { Card, Divider, Typography } from "antd";
import AddBulkScan from "../../../components/Comman/BulkInwardOutward/AddBulkScan";
import "../../../styles/global-ui.css";
import AddBulkScanGsm from "../../../components/Comman/BulkInwardOutward/AddBulkScanGsm";

const Gsm_BulkInwardPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            GSM Bin Bulk Inward
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Scan and receive multiple bins into garment supermarket
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />
    <Card className="modern-card">
      <AddBulkScanGsm
        title="Bin Bulk Inward"
        userData={userData}
        type="inward"
      />
      </Card>
    </div>
  );
};

export default Gsm_BulkInwardPage;